module.exports = __webpack_public_path__ + "static/media/p7.4e16e34a.jpg";